module.exports = __webpack_public_path__ + "static/media/screenshot-linkedin.030ca6f8.jpg";